export const DataFields = (t) => {
  return [
    {
      name: "",
      fields: [
        {
          id: "name",
          name: t('producttags_form_name'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "textColor",
          name: t('producttags_form_textcolor'),
          type: "color",
          required: true,
          defaultValue: "#000000",
          size: "small"
        },
        {
          id: "backgroundColor",
          name: t('producttags_form_backgroundcolor'),
          type: "color",
          required: true,
          defaultValue: "#ffffff",
          size: "small"
        },
        {
          id: "active",
          name: t('producttags_form_active'),
          type: "switch",
          required: true,
          defaultValue: false,
          size: "small"
        },
      ]
    }
  ]
}